<template>
  <div class="game-summary">
    <div class="blackBG-words"></div>
    <div class="modal">
      <div v-if="!results">
        <div v-if="text" class="description">
          {{
            text == "win"
              ? $t("engGame.eng-summery.welldone")
              : $t("engGame.eng-summery.improve")
          }}
        </div>
        <div v-if="text == 'lose'">
          <div class="engSen">{{ wengSen }}</div>
          <div class="hebSen">{{ whebSen }}</div>
        </div>
        <div class="description" v-if="text == 'win'">{{ outText }}</div>
        <Spacer height="12" v-if="audioSrc && text == 'win'" />
        <AudioPlayer v-if="audioSrc && text == 'win'" :audioSrc="audioSrc" />
        <Spacer height="12" v-if="vidSrc && text == 'win'" />
        <VideoPlayer1
          :vidSrc="makeLinkEmbaddable(vidSrc)"
          v-if="vidSrc && text == 'win'"
        />
        <Spacer height="12" v-if="imgSrc && text == 'win'" />
        <img v-if="imgSrc" id="img" :src="imgSrc && text == 'win'" />
        <Spacer height="12" />
      </div>
      <div class="flex btnsDiv">
        <button class="btnSummry btnRestart" @click="restartGame">
          {{ $t("engGame.eng-summery.again") }}
        </button>
        <!-- <button class="btnSummry btnRes" @click="results = true">
          תוצאות
        </button> -->
      </div>
      <button class="btnSummry btnGo" v-if="text == 'win'" @click="goBack">
        {{ $t("engGame.eng-summery.continue") }}
      </button>
    </div>
  </div>
</template>

<script>
import AudioBtn from "../Shared/audioBtn.vue";
import { userService } from "../../services/userService";

import AudioPlayer from "../Shared/AudioPlayer.vue";
import VideoPlayer from "../Shared/VideoPlayer.vue";

import VideoPlayer1 from "../Shared/VideoPlayer.vue";
import Spacer from "../Shared/Spacer.vue";
import { courseService } from "../../services/courseService";
export default {
  name: "SentanceSummery",
  props: {
    text: {
      type: String,
      default: ""
    },
    currentData: {
      type: Object,
      default: () => {}
    },
    externalData: {
      type: Object,
      default: () => {}
    },
    mistakes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      audioSrc: null,
      vidSrc: null,
      imgSrc: null,
      outText: null,
      exData: null,
      results: false,
      wengSen: "",
      whebSen: ""
    };
  },
  watch: {
    currentData() {
      if (this.currentData.game.outro_image)
        this.imgSrc = this.currentData.game.outro_image;
      if (this.currentData.game.outro_audio)
        this.audioSrc = this.currentData.game.outro_audio;
      if (this.currentData.game.outro_video)
        this.vidSrc = this.currentData.game.outro_video;
      if (this.currentData.game.outro_text)
        this.outText = this.currentData.game.outro_text;
    },
    exData() {
      if (this.exData.outro_image) this.imgSrc = this.exData.outro_image;
      if (this.exData.outro_audio) this.audioSrc = this.exData.outro_audio;
      if (this.exData.outro_video) this.vidSrc = this.exData.outro_video;
      if (this.exData.outro_text) this.outText = this.exData.outro_text;
    },
    mistakes() {
      console.log(this.mistakes);
      console.log(this.mistakes.length);
      if (this.mistakes && this.mistakes.length) {
        console.log(this.mistakes);
        this.whebSen = this.mistakes.at(-1).heb;
        this.wengSen = this.mistakes.eng
          .at(-1)
          .map(word => {
            return word.words;
          })
          .join(" ");
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
    // hebSen() {
    //   if (this.mistakes) {
    //     [last] = this.mistakes.slice(-1);
    //     if (last) {
    //       return last.heb;
    //     } else {
    //       return "";
    //     }
    //   }
    //   return "";
    // },
    // engSen() {
    //   if (this.mistakes) {
    //     console.log(this.mistakes);
    //     last = this.mistakes.at(-1);
    //     console.log(last);
    //     if (last) {
    //       return last.eng
    //         .map(word => {
    //           return word.words;
    //         })
    //         .join(" ");
    //     } else {
    //       return "";
    //     }
    //   }
    //   return "";
    // }
  },
  methods: {
    makeLinkEmbaddable: link => {
      if (String(link).includes("shorts")) {
        const youtubeID = String(link).split("/shorts/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      if (String(link).includes(".be/")) {
        const youtubeID = String(link).split(".be/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      const youtubeID = String(link).split("watch?v=")[1];
      return (
        "https://www.youtube.com/embed/" +
        youtubeID +
        "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
      );
    },

    restartGame() {
      this.$emit("restartGame");
    },
    async goBack() {
      // if (this.currentData) {
      //   await userService.finishLesson(this.$store.getters.nextLesson.id, this.user);
      // }

      this.$router.push("/chapter/");
    }
    // async goNext() {
    //   if (this.data) {
    //     await userService.finishLesson(this.$store.getters.nextLesson.id, this.user);
    //     var nextLesson = await userService.nextLesson(this.user);
    //   }
    //   this.$router.push(`/lesson/${nextLesson.id}`);
    // },
  },
  async mounted() {
    if (this.externalData)
      this.exData = await courseService.getGame(this.externalData.id);
    if (this.currentData) {
      if (this.currentData.game.outro_image)
        this.imgSrc = this.currentData.game.outro_image;
      if (this.currentData.game.outro_audio)
        this.audioSrc = this.currentData.game.outro_audio;
      if (this.currentData.game.outro_video)
        this.vidSrc = this.currentData.game.outro_video;
      if (this.currentData.game.outro_text)
        this.outText = this.currentData.game.outro_text;
    }
    console.log(this.mistakes);
    console.log(this.mistakes.length);
    if (this.mistakes && this.mistakes.length) {
      console.log(this.mistakes);
      this.whebSen = this.mistakes.at(-1).heb;
      this.wengSen = this.mistakes
        .at(-1)
        .eng.map(word => {
          return word.words;
        })
        .join(" ");
    }
  },
  components: {
    AudioBtn,
    AudioPlayer,
    VideoPlayer,
    VideoPlayer1,
    Spacer
  }
};
</script>

<style scoped>
button {
  border: none;
}
.progress-icon {
  height: 24px;
}
.translations {
  font: var(--medium-font);
  display: flex;
  flex-direction: column;
  width: 55%;
  text-align: center;
}
.word {
  border-bottom: 1px solid var(--color-primary);
  display: flex;
  height: 74px;
  align-items: center;
}
.btn-remove {
  border: 0.5px solid var(--color-primary);
  font: var(--small-font);
  border-radius: 14px;
  padding: 4px;
  margin: 0 10px;
}
.idx {
  margin: 0 12px;
  width: 0.5em;
}
.audio {
  margin-right: 6px;
  width: 1em;
}
.played-words {
  margin-top: 20px;
}
.saveWord {
  fill: var(--bg-primary);
}
.savedWord {
  fill: var(--saved-word);
}
.blackBG-words {
  background-color: var(--color-primary);
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 11;
  background-color: var(--bg-primary);
  opacity: 1;
  padding: 12px;
  border-radius: 4px;
  max-width: 80vw;
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
}
.backBtn {
  margin-bottom: 20px;
}
.btnSummry {
  border-radius: 6px;
  width: 100%;
  font: var(--large-font);
}
.btnRestart {
  color: #111199;
  background-color: #c4c8ff;
}
.btnGo {
  color: var(--button-primary-text);
  background-color: var(--button-primary);
  margin-top: 8px;
  height: 60px;
}
.btnRes {
  color: var(--color-primary-lt);
  background-color: var(--button-restart-primary);
}
.btnsDiv {
  gap: 5px;
  width: 100%;
  height: 50px;
}
.engSen {
  text-align: left;
  direction: var(--src-direction);
  font: var(--medium-font);
  margin-top: 10px;
}
.engSen:first-letter {
  text-transform: capitalize;
}
.hebSen {
  text-align: right;
  font: var(--medium-font);
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// eng-summery.vue?771bd347